import React from 'react'
import {Collapse} from 'antd'

import './index.css'

const BookingCollapse = (props) => {
  return <div className="custom-collapse"><Collapse {...props} /></div>
}

export default BookingCollapse
